import React from 'react';

export default () => (
  <div>
    Not Found
  </div>
);
